import { Link, useLocation, useNavigate } from '@tanstack/react-router'
import type { BottomNavItem } from '@trellis/roots/navigation'
import { BottomNav as RootsBottomNav } from '@trellis/roots/navigation'
import { FileText, Package, Plus, Receipt, ScrollText, Users } from 'lucide-react'

import { QuickCreateIcon } from './QuickCreateIcon'

const NAV_ITEMS: BottomNavItem[] = [
  { to: '/clients', label: 'Clients', icon: <Users /> },
  { to: '/quotes', label: 'Quotes', icon: <ScrollText /> },
  { to: '/invoices', label: 'Invoices', icon: <FileText /> },
  { to: '/expenses', label: 'Expenses', icon: <Receipt /> },
]

const FAB_OPTIONS: BottomNavItem[] = [
  { to: '/clients/new', label: 'New Client', icon: <QuickCreateIcon icon={Users} /> },
  { to: '/quotes/new', label: 'New Quote', icon: <QuickCreateIcon icon={ScrollText} /> },
  {
    to: '/invoices/new',
    label: 'New Invoice',
    icon: <QuickCreateIcon icon={FileText} />,
  },
  { to: '/expenses/new', label: 'New Expense', icon: <QuickCreateIcon icon={Receipt} /> },
  {
    to: '/line-items/new',
    label: 'New Line Item',
    icon: <QuickCreateIcon icon={Package} />,
  },
]

export function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()

  function handleSelect(path: string) {
    /* BottomNavItem.to from @trellis/roots is an untyped string, not the route-tree literal
     * union `to` expects — `href` bypasses that check for a value already known to be a
     * valid route (FAB_OPTIONS above only lists registered paths). */
    void navigate({ href: path })
  }

  return (
    <RootsBottomNav
      items={NAV_ITEMS}
      fab={{
        icon: <Plus className="size-6" />,
        label: 'Quick Create',
        options: FAB_OPTIONS,
      }}
      currentPath={location.pathname}
      onSelect={handleSelect}
      linkComponent={Link}
    />
  )
}
